// eslint-disable-next-line import/no-webpack-loader-syntax
import NetworkTrainerWorker from "worker-loader!./networkTrainer";

export default NetworkTrainerWorker;
